import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import type { WebsiteHeaderLayout_PhotoArch } from '@shared/types/WebsiteHeaderSettings.types';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { PhotoArch } from '@apps/guest/packages/layout-engine/widgets/Custom/components';
import { useColorPaletteProvider } from '../../../../ColorPaletteProvider/ColorPaletteProvider';
import { Box } from '@withjoy/joykit';

interface PhotoArchLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PhotoArch;
  showPlaceholder?: boolean;
}

export const PhotoArchLayout = (props: PhotoArchLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photo = websiteHeader.headerPhoto.photos?.[0];

  const { pageColor, pageFontColor } = useColorPaletteProvider();

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <Box padding={[6, null, 0]}>
          <PhotoArch
            photo={photo}
            showPlaceholder={showPlaceholder}
            innerArchColor={pageColor}
            outerArchColor={pageFontColor}
          />
        </Box>
      </HeaderPhoto>
    </EventNameNav>
  );
};
